import React, {Component} from 'react';
import {connect} from 'react-redux';
import Engineers from '../../shared/Engineers';

import {
    fetchBranches,
    fetchEngineers,
    syncEngineers,
    updateEngineer,
    uploadEngineerDocument,
    deleteEngineerDocument
} from '../../../actions';

class EngineersContainer extends Component {
    componentDidMount() {
        const {belongsTo, fetchBranches} = this.props;
        return fetchBranches(belongsTo);
    }
    render() {
        const generateUrl = (belongsTo, engineer, doc) => {
            return `/api/landlord/${belongsTo}/dlo/engineers/${engineer}/documents/${doc}`;
        };

        return <Engineers {...this.props} generateDocUrl={generateUrl} />;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        belongsTo: state.me.application.id,
        engineers: state.landlord.dlo.engineers,
        settings: state.landlord.dlo.settings.data,
        branches: state.landlord.branches
    }
};

export default connect(mapStateToProps, {
    fetchBranches,
    fetchEngineers,
    syncEngineers,
    updateEngineer,
    uploadEngineerDocument,
    deleteEngineerDocument,
})(EngineersContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/DLO/EngineersContainer.js